import * as React from 'react';

import { EventFieldOptions, ReportType } from '../api/clients';

import ErrorOverlay from '../../components/ErrorOverlay';
import LoadingOverlay from '../../components/LoadingOverlay';
import useGetEventReportFieldOptions from '../api/hooks/event-report/useGetEventReportFieldOptions';

const DispatchEventFieldOptionsContext = React.createContext<EventFieldOptions>(undefined!);

// eslint-disable-next-line max-len
export function DispatchEventFieldOptionsProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const dispatchEventFieldOptions = useGetEventReportFieldOptions(ReportType.DispatchEventReport);

  if (dispatchEventFieldOptions.isLoading) {
    return (
      <LoadingOverlay />
    );
  }

  if (dispatchEventFieldOptions.status === 'error') {
    return (
      <ErrorOverlay
        title={dispatchEventFieldOptions?.error?.title}
        message="An error occurred retrieving data"
      />
    );
  }

  if (dispatchEventFieldOptions.data) {
    return (
      <DispatchEventFieldOptionsContext.Provider value={dispatchEventFieldOptions.data}>
        {children}
      </DispatchEventFieldOptionsContext.Provider>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <React.Fragment />;
}

export const useDispatchEventFieldOptions = () => React.useContext(DispatchEventFieldOptionsContext);
